import style from "./styles/SearchBar.module.css";

import { useState } from "react";
import { useDispatch } from "react-redux";

import { getInfo } from "../../redux/actions";

// Order imports
// Styles
// Native and other dependences
// Actions Redux
// Actions Controllers and constants
// Components
// Interfaces

const SearchBar = () => {
  const [search, setSearch] = useState<string>(""); // Luego veo si lo uso para
  // const [memoSearch, setMemoSearch] = useState<string>("");
  const dispatch = useDispatch();

  const getVideos = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (search) {
      // console.log('llamo a la pai con una búsqueda ', search)
      // setMemoSearch(search);
      dispatch(getInfo(search));
    }
  };

  return (
    <div className={style.mainSearch}>
      <form className={style.searchForm}>
        <input
          type="text"
          value={search}
          placeholder="Type here..."
          className={style.searchInput}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button className={style.searchButton} onClick={(e) => getVideos(e)}>
          <svg
            className={style.searchIcon}
            aria-hidden="true"
            viewBox="0 0 24 24"
          >
            <g>
              <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path>
            </g>
          </svg>
        </button>
      </form>
    </div>
  );
};

export default SearchBar;
